import React, { Component } from "react";
import { connect } from "react-redux";

import AreaHeader from "./AreaHeader";
import FieldNames from "../../../aiim/datasets/FieldNames";
import OfficePlan from "../../base/OfficePlan";
//import Panel from "../../../common/components/Panel";
import PeopleAndUnits from "./PeopleAndUnits";
import Rdx from "../../../redux/Rdx";
import Topic from "../../../context/Topic";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as component from "../../../components/util/component";

import { TitleRow } from '../../styles/Work/workBar';

class HotelAreaDetails extends Component {

    _mounted = false;

    constructor(props) {
        super(props);
        this.state = {
            areaItem: this.props.areaItem || null
        };
    }

    componentDidMount() {
        this._mounted = true;
        component.own(this, [
            Topic.subscribe(Topic.PlanModified, params => {
                const actions = [OfficePlan.Action_AssignmentsUpdated];
                if (actions && actions.indexOf(params.action) !== -1) {
                    component.refresh(this);
                }
            })
        ]);
    }

    componentWillUnmount() {
        component.componentWillUnmount(this);
        this._mounted = false;
    }

    getAreaId() {
        const areaItem = this.getAreaItem();
        return aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_ID);
    }

    getAreaItem() {
        return this.state.areaItem || this.props.areaItem;
    }

    getAreaType() {
        return OfficePlan.SpaceAssignmentTypes.hotel;
    }

    hasActive() {
        return !!(this.props.rdxActiveAreaId);
    }

    isActive() {
        return (this.hasActive() && this.props.rdxActiveAreaId === this.getAreaId());
    }

    render() {
        const { areaItem } = this.state;
        const { rdxActiveAreaKey, rdxActiveAreaId } = this.props;
        const areaType = this.getAreaType();
        return (
          <>
            <TitleRow>
                <AreaHeader areaItem={areaItem} areaType={areaType} rdxActiveAreaKey={rdxActiveAreaKey} rdxActiveAreaId={rdxActiveAreaId} />
            </TitleRow>
            <PeopleAndUnits areaItem={areaItem} areaType={areaType} />
          </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const rdxActiveAreaKey = Rdx.Keys.ACTIVE_HOTEL_AREA_ID;
    return {
        rdxActiveAreaId: Rdx.getValue(state, rdxActiveAreaKey)
    }
}

export default connect(mapStateToProps)(HotelAreaDetails);
